<ng-container>
  <div mat-dialog-title
    fxLayout='row'
    fxLayoutAlign='space-between start'>
    <div class="dialog-title">{{title}}</div>
    <button
      mat-icon-button
      type="button"
      class="icon-close"
      aria-label="Close"
      cdkFocusInitial
      #closeButton
      (click)="handleCancel()">
      <mat-icon class="mat-icon-rtl-mirror">close</mat-icon>
    </button>
  </div>
  <mat-dialog-content class="dialog-content thin-scrollbar">
    <div class="inform-content">
      <pre>{{message}}</pre>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button
      appToastMessage
      appSupportCopy
      [dataCopy]="message"
      [toastMessage]="toastMessage"
      class="special-button">{{acceptText}}</button>
    <button mat-raised-button
      class="special-button"
      mat-dialog-close
      (click)="handleCancel()">{{cancelText}}</button>
  </mat-dialog-actions>
</ng-container>
